import { Environment, EnvironmentConfiguration } from '../types/environment';
import EnvironmentStore from '../rx-stores/environment';
import {
  ON_PREM,
  ON_PREM_SENSEI_API_BASE_URL,
  ON_PREM_CORE_CUCUMBER_BASE_URL,
  ON_PREM_ERROR_COLLECTOR_BASE_URL,
} from './environment';

const SENSEI_API_BASE_URL = 'https://sensei-api.density.io';
const CORE_CUCUMBER_BASE_URL = 'https://core-cucumber.density.io';

export const Hosts = {
  get SenseiApiLocalHost() {
    return `http://localhost:8087/v1`;
  },
  get SenseiApiHost() {
    const configuration = EnvironmentStore.imperativelyGetValue().configuration;
    switch (configuration.type) {
      case Environment.PRODUCTION:
        const base = ON_PREM
          ? ON_PREM_SENSEI_API_BASE_URL
          : SENSEI_API_BASE_URL;
        return `${base}/v1`;
      case Environment.STAGING:
        return 'https://sensei-api.kgm3.net/v1';
      case Environment.LOCAL:
        return `http://localhost:${configuration.port}/v1`;
      case Environment.CUSTOM:
        return configuration.senseiApiBaseUrl;
    }
  },
  get CoreCucumberHost() {
    const configuration = EnvironmentStore.imperativelyGetValue().configuration;
    switch (configuration.type) {
      case Environment.PRODUCTION:
        const base = ON_PREM
          ? ON_PREM_CORE_CUCUMBER_BASE_URL
          : CORE_CUCUMBER_BASE_URL;
        return `${base}/admin`;
      case Environment.STAGING:
        return 'https://core-cucumber-staging.density.io/admin';
      case Environment.LOCAL:
        return `https://localhost:8000/admin`;
      case Environment.CUSTOM:
        return configuration.coreCucumberBaseUrl;
    }
  },
  get ClientId() {
    // if (ON_PREM) {
    //   return null;
    // }
    switch (window.location.hostname) {
      case 'sensei.density.io':
        return 'OD8Fc3NzPp67l5PzA5pr0iOVIvLtI2oM';
      case 'sensei.density.rodeo':
        return '1pIfE60VsaiVoL4uXtVVR1pyWURWDFHd';
      case 'localhost':
      case '127.0.0.1':
      default:
        return 'OD8Fc3NzPp67l5PzA5pr0iOVIvLtI2oM';
    }
  },
  get SentryHost() {
    // if (ON_PREM) {
    //   return null;
    // }
    switch (window.location.hostname) {
      case 'sensei.density.io':
        return 'production';
      case 'sensei.density.rodeo':
        return 'staging';
      default:
        return null;
    }
  },
  get ErrorCollectorHost() {
    if (!ON_PREM) {
      throw new Error(
        'The error collector is only available in on prem environments.',
      );
    }
    return ON_PREM_ERROR_COLLECTOR_BASE_URL;
  },
  AnnotationToolHost: 'https://annotate.density.cloud',
};
